var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStampsBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.43,
    height: 59.405,
    viewBox: "0 0 59.43 59.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4618",
    "data-name": "Grupo 4618",
    transform: "translate(2.167 2.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-actions-check-simple",
    transform: "translate(20.134 22.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M5.15,12.591,10.7,18.127,22.389,7.96",
    transform: "translate(-5.15 -7.96)",
    fill: "none",
    stroke: "#5128e2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic-ecommerce-badge",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M51.924,22.353l.881-5.537a3,3,0,0,0-1.913-3.322l-5.21-2.013L43.695,6.3a3,3,0,0,0-3.3-1.913l-5.537.881L30.532,1.742a3.02,3.02,0,0,0-3.825,0L22.353,5.265l-5.537-.881A3,3,0,0,0,13.494,6.3l-2.013,5.21L6.3,13.494a3,3,0,0,0-1.913,3.3l.881,5.537L1.742,26.657a3.02,3.02,0,0,0,0,3.825l3.523,4.329-.881,5.537A3,3,0,0,0,6.3,43.695l5.21,2.013,1.988,5.184a3,3,0,0,0,3.3,1.913l5.537-.881,4.329,3.523a3.02,3.02,0,0,0,3.825,0l4.329-3.523,5.537.881a3,3,0,0,0,3.347-1.913l2.013-5.21,5.21-2.013a3,3,0,0,0,1.913-3.3l-.881-5.537,3.523-4.329a3.02,3.02,0,0,0,0-3.825Z",
    transform: "translate(-1.059 -1.059)",
    fill: "none",
    stroke: "#5128e2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampsBlue);
export default __webpack_public_path__ + "static/media/stamps_blue.9bc2e5fe22a052ba7c39abf198ffd684.svg";
export { ForwardRef as ReactComponent };